// Fixed-price packages. Prices are drafts until the consultant confirms them.
// VAT_SUFFIX: set to "" if Electra HR Ltd is not VAT-registered.
export const VAT_SUFFIX = " + VAT";
export const MEMBERSHIP_PRICE = 39;

export const PACKAGES = [
  { id: "hr-question", name: "Ask an HR adviser", detail: "One written question, one clear written answer", price: 95, from: false, turnaround: "Within 1 working day", service: "day-to-day-hr-advice" },
  { id: "contract", name: "Employment contract", detail: "One role, day-one compliant", price: 195, from: false, turnaround: "3 working days", service: "contracts-handbooks" },
  { id: "handbook", name: "Staff handbook", detail: "Up to 25 staff, plain English", price: 695, from: true, turnaround: "2 weeks", service: "contracts-handbooks" },
  { id: "disciplinary-grievance", name: "Disciplinary or grievance support", detail: "One case: plan, scripts and letters, with your adviser on video for the meetings if you want", price: 495, from: true, turnaround: "Started within 1 working day", service: "grievances-disciplinaries" },
  { id: "investigation", name: "Independent investigation", detail: "Interviews and a written report", price: 895, from: true, turnaround: "Report within 2 weeks", service: "grievances-disciplinaries" },
  { id: "health-check", name: "HR health check", detail: "Up to 20 staff: written report and a fixed-price fix list", price: 795, from: false, turnaround: "2 weeks", service: "hr-health-checks" },
  { id: "redundancy", name: "Small redundancy process", detail: "Under 20 roles: process plan, letters and consultation scripts", price: 995, from: true, turnaround: "Plan within 3 working days", service: "training-and-change" },
  { id: "equality-action-plan", name: "Equality action plan drafting", detail: "Gender pay gap and menopause actions chosen with you, supporting text and narrative drafted for sign-off", price: 995, from: true, turnaround: "2 weeks", service: "equality" },
  { id: "startup", name: "Startup HR foundations", detail: "Contracts, handbook and onboarding", price: 1495, from: true, turnaround: "3 to 4 weeks", service: "startup-packages" },
];

// Blocks of hours: paid up front, used within 12 months of purchase, time recorded
// and reported to the client. Covers day-to-day HR; defined projects are priced separately.
export const HOURLY_RATE = 160;
export const HOUR_BLOCKS = [
  { id: "block-5", hours: "5", price: 800, saving: "Standard rate", use: "A live issue, a hard conversation, a sanity check before you act." },
  { id: "block-10", hours: "10", price: 1520, saving: "5% off", use: "A few issues across the year, handled as they come up." },
  { id: "block-15", hours: "15", price: 2160, saving: "10% off", use: "Regular day-to-day cover for a growing team." },
  { id: "block-20", hours: "20", price: 2720, saving: "15% off", use: "Your HR department on tap, without the retainer." },
];

export const formatPrice = (p) => `${p.from ? "From " : ""}£${p.price.toLocaleString("en-GB")}${VAT_SUFFIX}`;

export const packagesForService = (slug) => PACKAGES.filter((p) => p.service === slug);

// Cheapest package for a service, used for "from £X" lines.
export const lowestForService = (slug) => {
  const list = packagesForService(slug);
  if (!list.length) return null;
  const p = list.reduce((a, b) => (b.price < a.price ? b : a));
  return { ...p, from: list.length > 1 || p.from };
};

// Options for the enquiry form.
export const ENQUIRY_OPTIONS = [
  ...PACKAGES.map((p) => ({ value: p.id, label: p.name })),
  ...HOUR_BLOCKS.map((b) => ({ value: b.id, label: `${b.hours}-hour block` })),
  { value: "membership", label: "Members' horizon scan" },
  { value: "other", label: "Something else / not sure" },
];
